<div class="card record-list-card" data-shared-list-component>
  <div class="alert alert-warning m-2" role="alert" *ngIf="preferenceError">
    Could not load or save list preferences: {{ preferenceError }}
  </div>
  <div class="card-header p-2 record-list-toolbar sticky-list-tools" *ngIf="showToolbar">
    <div class="row g-1 align-items-center w-100">
      <div class="col record-list-search-column">
        <div class="input-icon">
          <span class="input-icon-addon" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
              <path d="M21 21l-6 -6"></path>
            </svg>
          </span>
          <input
            type="search"
            class="form-control record-list-control"
            [disabled]="loading || !!configError"
            [ngModel]="searchText"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Search records"
            aria-label="Search records"
          />
        </div>
      </div>

      <div class="col-auto" *ngFor="let column of visibleFilters; trackBy: trackColumn">
        <button
          cdkOverlayOrigin
          #filterOrigin="cdkOverlayOrigin"
          type="button"
          class="btn btn-sm rounded-2 record-list-control"
          [class.active]="!!internalState.filters[column.key]"
          [disabled]="loading"
          (click)="toggleFilter(column)"
        >
          <span class="text-truncate">{{ filterButtonLabel(column) }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon-end icon-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 6l6 -6"></path>
          </svg>
        </button>

        <app-floating-dropdown
          [origin]="filterOrigin"
          [open]="openFilterKey === column.key"
          align="end"
          panelClass="p-3 shadow record-list-filter-menu"
          minWidth="19rem"
          (openChange)="setFilterOpen(column, $event)"
        >
          <ng-container *ngIf="isOptionFilter(column); else comparisonFilter">
            <input
              type="search"
              class="form-control form-control-sm mb-2"
              [ngModel]="optionSearch[column.key] || ''"
              (ngModelChange)="onOptionSearchChange(column, $event)"
              [placeholder]="'Search ' + headerLabel(column)"
            />
            <div class="record-list-options">
              <label
                class="form-check record-list-option"
                *ngFor="let option of optionsFor(column); trackBy: trackOption"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="isOptionSelected(column, option)"
                  (change)="toggleOption(column, option, $any($event.target).checked)"
                />
                <span class="form-check-label text-truncate" [title]="option.label">
                  {{ option.label }}
                </span>
              </label>
              <div class="text-secondary small py-2" *ngIf="optionLoading[column.key]">
                Loading values…
              </div>
              <div
                class="text-secondary small py-2"
                *ngIf="!optionLoading[column.key] && optionsFor(column).length === 0"
              >
                No values found.
              </div>
            </div>
            <div class="text-secondary small mt-2" *ngIf="hiddenOptionCount(column) > 0">
              {{ hiddenOptionCount(column) }} more values are hidden. Search to narrow the list.
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button type="button" class="btn btn-sm text-danger" (click)="clearFilter(column)">
                Clear
              </button>
            </div>
          </ng-container>

          <ng-template #comparisonFilter>
            <label class="form-label small mb-1">{{ headerLabel(column) }}</label>
            <select
              class="form-select form-select-sm mb-2"
              [ngModel]="filterOperator(column)"
              (ngModelChange)="setOperator(column, $event)"
            >
              <option *ngFor="let operator of operatorOptions(column)" [ngValue]="operator.value">
                {{ operator.label }}
              </option>
            </select>
            <ng-container *ngIf="filterOperator(column) !== 'between'; else betweenInputs">
              <input
                class="form-control form-control-sm"
                [type]="comparisonInputType(column)"
                [ngModel]="filterValues(column)[0] || ''"
                (ngModelChange)="setComparisonValue(column, $event)"
              />
            </ng-container>
            <ng-template #betweenInputs>
              <div class="row g-2">
                <div class="col">
                  <label class="form-label small mb-1">From</label>
                  <input
                    class="form-control form-control-sm"
                    [type]="comparisonInputType(column)"
                    [ngModel]="filterValues(column)[0] || ''"
                    (ngModelChange)="setComparisonValue(column, $event, 0)"
                  />
                </div>
                <div class="col">
                  <label class="form-label small mb-1">To</label>
                  <input
                    class="form-control form-control-sm"
                    [type]="comparisonInputType(column)"
                    [ngModel]="filterValues(column)[1] || ''"
                    (ngModelChange)="setComparisonValue(column, $event, 1)"
                  />
                </div>
              </div>
            </ng-template>
            <div class="d-flex justify-content-end mt-2">
              <button type="button" class="btn btn-sm text-danger" (click)="clearFilter(column)">
                Clear
              </button>
            </div>
          </ng-template>
        </app-floating-dropdown>
      </div>

      <div class="col-auto" *ngIf="hiddenFilters.length > 0">
        <button
          type="button"
          class="btn btn-sm record-list-control"
          [class.active]="showAllFilters"
          [disabled]="loading"
          (click)="showAllFilters = !showAllFilters"
        >
          {{ showAllFilters ? 'Fewer filters' : 'More filters' }}
          <span class="badge bg-secondary text-secondary-fg ms-1" *ngIf="!showAllFilters">
            +{{ hiddenFilters.length }}
          </span>
        </button>
      </div>

      <div class="col-auto" *ngIf="activeFilterCount > 0">
        <button
          type="button"
          class="btn btn-sm record-list-control active"
          [disabled]="loading"
          (click)="clearAllFilters()"
        >
          Clear filters
          <span class="badge bg-blue text-blue-fg ms-1">{{ activeFilterCount }}</span>
        </button>
      </div>

      <div class="col-auto" *ngIf="availableViewTypes.length > 1">
        <app-business-document-view-toggle></app-business-document-view-toggle>
      </div>

      <div class="col-auto" *ngIf="hasActions">
        <button
          cdkOverlayOrigin
          #actionsOrigin="cdkOverlayOrigin"
          type="button"
          class="btn dropdown-toggle record-list-control"
          [disabled]="loading"
          (click)="actionsOpen = !actionsOpen"
        >
          Actions
          <span class="badge bg-secondary text-secondary-fg ms-2" *ngIf="selectionCount > 0">
            {{ selectionCount }}
          </span>
        </button>
        <app-floating-dropdown
          [origin]="actionsOrigin"
          [open]="actionsOpen"
          align="end"
          panelClass="p-1 shadow"
          minWidth="13rem"
          (openChange)="actionsOpen = $event"
        >
          <ng-container *ngFor="let item of visibleActions">
            <div class="dropdown-divider" *ngIf="item.dividerBefore"></div>
            <button
              type="button"
              class="dropdown-item"
              [ngClass]="actionClass(item)"
              [disabled]="!isActionEnabled(item)"
              (click)="runAction(item)"
            >
              {{ item.label }}
            </button>
          </ng-container>
          <div class="dropdown-item-text text-secondary small" *ngIf="visibleActions.length === 0">
            No actions are available for this selection.
          </div>
          <ng-container *ngIf="selectionCount > 0">
            <div class="dropdown-divider"></div>
            <button
              type="button"
              class="dropdown-item"
              (click)="clearSelection(); actionsOpen = false"
            >
              Clear selection
            </button>
          </ng-container>
        </app-floating-dropdown>
      </div>
    </div>
  </div>

  <div class="alert alert-danger m-3" data-local-alert *ngIf="configError">
    <strong>Record-list configuration error</strong>
    <div>{{ configError }}</div>
  </div>
  <div class="alert alert-danger m-3" data-local-alert *ngIf="errorMessage">
    <strong>Record query error</strong>
    <div>{{ errorMessage }}</div>
    <button *ngIf="tree && query && !recordsError" type="button" class="btn btn-sm mt-2" (click)="retryTree()">Retry hierarchy</button>
  </div>
  <div class="alert alert-danger m-3" data-local-alert *ngIf="pipelineError">
    <strong>Pipeline error</strong>
    <div>{{ pipelineError }}</div>
  </div>

  <div *ngIf="businessDocumentEnabled && viewMode === 'kanban'" class="card-body p-3 overflow-auto">
    <div *ngIf="loading || pipelineLoading" class="text-center text-secondary py-5">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Loading pipeline records…
    </div>
    <app-business-document-kanban
      *ngIf="!loading && !pipelineLoading"
      [columns]="kanbanColumns"
      [draggable]="kanbanDraggable"
      [emptyMessage]="emptyLabel"
      [cardComponent]="$any(cardComponent)"
      [cardContext]="cardConfiguration?.context || {}"
      (cardMoved)="moveKanbanCard($event)"
      (cardOpened)="openKanbanCard($event)"
    ></app-business-document-kanban>
  </div>

  <div *ngIf="viewMode === 'card'" class="card-body p-3">
    <div *ngIf="loading" class="text-center text-secondary py-5">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Loading records…
    </div>
    <div
      *ngIf="!loading && !errorMessage && !configError && rows.length === 0"
      class="text-center text-secondary py-5">
      {{ emptyLabel }}
    </div>
    <div
      *ngIf="!loading && rows.length"
      class="record-list-card-grid"
      [style.--record-card-columns]="cardColumns">
      <ng-container *ngFor="let row of rows; trackBy: trackRow">
        <div
          *ngIf="cardConfiguration?.interactiveContent; else linkedCard"
          class="record-list-owner-card record-list-owner-card-interactive">
          <ng-container *ngComponentOutlet="$any(cardComponent); inputs: cardInputs(row)"></ng-container>
        </div>
        <ng-template #linkedCard>
          <a
            *ngIf="cardRouterLink(row) as route; else emittedCard"
            class="record-list-owner-card"
            [routerLink]="route"
            [attr.target]="cardConfiguration?.link?.openInNewTab ? '_blank' : null">
            <ng-container *ngComponentOutlet="$any(cardComponent); inputs: cardInputs(row)"></ng-container>
          </a>
          <ng-template #emittedCard>
            <button type="button" class="record-list-owner-card" (click)="openCard(row)">
              <ng-container *ngComponentOutlet="$any(cardComponent); inputs: cardInputs(row)"></ng-container>
            </button>
          </ng-template>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div *ngIf="viewMode === 'list'" class="table-responsive">
    <table class="table table-vcenter card-table table-hover record-list-table" [attr.aria-label]="tree ? 'Record hierarchy' : null">
      <thead>
        <tr>
          <th class="w-1" *ngIf="hasActions">
            <input
              type="checkbox"
              class="form-check-input m-0"
              aria-label="Select all records"
              [checked]="allSelected"
              [disabled]="loading || rows.length === 0"
              (change)="toggleAll($any($event.target).checked)"
            />
          </th>
          <th
            *ngFor="let column of displayColumns; trackBy: trackColumn"
            [ngClass]="headerClass(column)"
            [class.record-list-sortable]="column.sortable"
            [attr.role]="column.sortable ? 'button' : null"
            [attr.tabindex]="column.sortable ? 0 : null"
            [attr.aria-sort]="
              internalState.sort?.key === column.key
                ? internalState.sort?.direction === 'asc'
                  ? 'ascending'
                  : 'descending'
                : null
            "
            (click)="sortBy(column)"
            (keydown)="onSortKeydown($event, column)"
          >
            <span>{{ headerLabel(column) }}</span>
            <span class="text-secondary small ms-1" *ngIf="column.sortable">
              {{ sortIcon(column) }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td [attr.colspan]="displayColumns.length + (hasActions ? 1 : 0)" class="text-center text-secondary py-5">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Loading records…
          </td>
        </tr>
        <tr *ngIf="!loading && !errorMessage && !configError && rows.length === 0">
          <td [attr.colspan]="displayColumns.length + (hasActions ? 1 : 0)" class="text-center text-secondary py-5">
            {{ emptyLabel }}
          </td>
        </tr>
        <tr *ngFor="let row of rows; let rowIndex = index; trackBy: trackRow"
          [attr.data-tree-depth]="treeRow(row)?.depth" [class.record-list-tree-context]="treeRow(row)?.contextOnly">
          <td class="w-1" *ngIf="hasActions">
            <input
              type="checkbox"
              class="form-check-input m-0"
              aria-label="Select record"
              [checked]="isSelected(row, rowIndex)"
              (change)="toggleRow(row, rowIndex, $any($event.target).checked)"
            />
          </td>
          <td
            *ngFor="let column of displayColumns; trackBy: trackColumn"
            class="record-list-cell"
            [ngClass]="column.className || ''"
            [title]="cellTitle(row, column)"
          >
            <div [class.d-flex]="tree && column.primary" [class.align-items-center]="tree && column.primary"
              [style.padding-inline-start.rem]="tree && column.primary ? (treeRow(row)?.depth || 0) * 1.25 : null">
            <ng-container *ngIf="tree && column.primary">
              <button *ngIf="treeRow(row)?.hasChildren; else treeLeaf" type="button" class="btn btn-sm btn-icon p-0 me-1 record-list-tree-toggle"
                [attr.aria-label]="(treeRow(row)?.expanded ? 'Collapse ' : 'Expand ') + cellTitle(row, column)"
                [attr.aria-expanded]="treeRow(row)?.expanded" [disabled]="activeFilterCount > 0"
                [title]="activeFilterCount ? 'Matching ancestors stay expanded while filtering' : ''" (click)="toggleTreeRow(row)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
                  [style.transform]="treeRow(row)?.expanded ? null : 'rotate(-90deg)'"><path d="m6 9 6 6 6 -6"></path></svg>
              </button>
              <ng-template #treeLeaf><span class="record-list-tree-toggle me-1 flex-shrink-0" aria-hidden="true"></span></ng-template>
            </ng-container>
            <ng-container *ngIf="cellTemplates[column.key] as ownerCell; else defaultCell"
              [ngTemplateOutlet]="ownerCell" [ngTemplateOutletContext]="{ $implicit: row, row: row, column: column }"></ng-container>
            <ng-template #defaultCell>
            <a
              *ngIf="hasCellLink(row, column) && !column.link?.openInNewTab; else newTabOrPlain"
              [routerLink]="linkFor(row, column)"
              class="record-list-link fw-bold link-primary link-offset-3 link-underline link-underline-opacity-50 link-underline-opacity-100-hover"
            >
              <ng-container
                [ngTemplateOutlet]="cellContent"
                [ngTemplateOutletContext]="{ row: row, column: column }"
              ></ng-container>
            </a>
            <ng-template #newTabOrPlain>
              <a
                *ngIf="hasCellLink(row, column) && column.link?.openInNewTab; else plainCell"
                appOpenInNewTab
                [routerLink]="linkFor(row, column)"
                class="record-list-link fw-bold link-primary link-offset-3 link-underline link-underline-opacity-50 link-underline-opacity-100-hover"
              >
                <ng-container
                  [ngTemplateOutlet]="cellContent"
                  [ngTemplateOutletContext]="{ row: row, column: column }"
                ></ng-container>
              </a>
              <ng-template #plainCell>
                <a
                  *ngIf="column.openRecord; else valueOnly"
                  type="button"
                  class="record-list-link fw-bold link-primary link-offset-3 link-underline link-underline-opacity-50 link-underline-opacity-100-hover"
                  (click)="recordOpen.emit(row)"
                >
                  <ng-container
                    [ngTemplateOutlet]="cellContent"
                    [ngTemplateOutletContext]="{ row: row, column: column }"
                  ></ng-container>
                </a>

                <ng-template #valueOnly>
                <ng-container
                  [ngTemplateOutlet]="cellContent"
                  [ngTemplateOutletContext]="{ row: row, column: column }"
                ></ng-container>
                </ng-template>
              </ng-template>
            </ng-template>
            </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="hasColumnTotals" aria-label="Full filtered totals">
        <tr>
          <td *ngIf="hasActions"></td>
          <td *ngFor="let column of displayColumns; let index = index; trackBy: trackColumn" [ngClass]="column.className || ''">
            <span *ngIf="index === 0" class="text-secondary">Total (full filter)</span>
            <strong *ngIf="column.total" class="d-block text-end">{{ columnTotal(column) }}</strong>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="card-footer d-flex flex-wrap align-items-center justify-content-between gap-2" *ngIf="showPagination || editPipelineRoute">
    <span *ngIf="tree && !loading && !errorMessage && !configError" class="small text-secondary">{{ treeMatchedCount }} matching records · {{ total }} root records · pages keep subtrees together</span>
    <app-pagination
      *ngIf="showPagination"
      [pagination]="{
        page: internalState.page,
        perPage: internalState.perPage,
        total: total,
        totalPages: totalPages,
      }"
      [loading]="loading"
      (pageChange)="onPageChange($event)"
      (perPageChange)="onPerPageChange($event)"
    ></app-pagination>
    <a *ngIf="editPipelineRoute" class="small link-primary" [routerLink]="editPipelineRoute">
      {{ editPipelineLabel }}
    </a>
  </div>
</div>

<div
  class="record-list-floating-pipeline-control d-print-none"
  *ngIf="businessDocumentEnabled && viewMode === 'kanban' && pipelineOptions.length > 1"
>
  <app-business-document-pipeline-picker
    [options]="pipelineOptions"
    [value]="selectedPipelineId"
    [disabled]="loading || pipelineLoading"
    ariaLabel="Select business document pipeline"
    (valueChange)="selectPipeline($event)"
  ></app-business-document-pipeline-picker>
</div>

<ng-template #cellContent let-row="row" let-column="column">
  <span class="d-inline-flex align-items-center gap-2 mw-100">
    <span *ngIf="column.avatar" [ngClass]="avatarClass(column)">
      <img
        *ngIf="avatarImage(row, column); else avatarInitial"
        [src]="avatarImage(row, column)"
        alt=""
        class="avatar-img"
      />
      <ng-template #avatarInitial>{{ avatarInitials(row, column) }}</ng-template>
    </span>
    <span *ngIf="column.badge; else plainValue" [ngClass]="badgeClass(row, column)">
      {{ displayValue(row, column) }}
    </span>
    <ng-template #plainValue>
      <span class="text-truncate">{{ displayValue(row, column) }}</span>
    </ng-template>
  </span>
</ng-template>
